export default "__VITE_ASSET__DVaPqhRo__"